<template>
  <v-app>
    <!-- Toolbar -->
    <prosic-header></prosic-header>
    <prosic-time></prosic-time>

    <!-- End Toolbar -->

    <!-- Body -->
    <v-content fluid>
      <prosic-loader></prosic-loader>
      <prosic-system-status></prosic-system-status>
      <prosic-tutorial-init></prosic-tutorial-init>
      <transition name="fade">
        <router-view :class="{ 'mt-4': appName.includes('QA') }" />
      </transition>
    </v-content>
    <!-- End Body -->

    <!-- Footer -->

    <prosic-snackbar></prosic-snackbar>
    <prosic-footer app></prosic-footer>
    <!-- End Footer -->
  </v-app>
</template>

<script>
import { app } from "@/config/globals";
import Header from "@/components/layout/Header";
import Time from "@/components/layout/Time";
import Footer from "@/components/layout/Footer";
import Snackbar from "@/components/layout/Snackbar";
import SystemStatus from "@/components/layout/SystemStatus";
import TutorialInit from "@/components/layout/TutorialInit";
import Loader from "@/components/layout/Loader";
import { mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {
      appName: app.name
    };
  },
  components: {
    ProsicHeader: Header,
    ProsicFooter: Footer,
    ProsicSnackbar: Snackbar,
    ProsicLoader: Loader,
    ProsicTime: Time,
    ProsicSystemStatus: SystemStatus,
    ProsicTutorialInit: TutorialInit
  },
  created() {
    // Check in case we are server-side rendering:
    this.userOnlineStatus();
    if (typeof window !== undefined) {
      window.addEventListener("beforeinstallprompt", this.installHandler);
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("beforeinstallprompt", this.installHandler);
      });
    }
  },
  beforeMount() {
    this.connectedUserAnalyctis();
  },
  methods: {
    ...mapActions("pwa", ["installHandler"]),
    ...mapActions("user", ["connectedUserAnalyctis", "userOnlineStatus"])
  }
};
</script>
<style lang="css">
.font-extralight {
  font-weight: 200;
}
.v-application,
.v-application .title,
.v-application .headline,
.v-application .display-3,
.v-application .display-2,
.v-application .display-1,
.v-application .body-1,
.v-application .body-2 {
  font-family: "Oswald", sans-serif !important;
  letter-spacing: unset !important;
}

.v-btn {
  letter-spacing: unset;
}
.theme--light.v-application {
    background: #f6f6f6 !important;
}
</style>
